// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tabs {
  position: relative;
  white-space: nowrap;
  scrollbar-width: none;
}
.tabs::-webkit-scrollbar {
  display: none;
}
.tabs .tab {
  width: auto;
}
.tabs .tab div {
  display: inline-block;
}
.tabs a {
  text-decoration: none;
  font-size: 14px;
  padding: 4px 4px 6px;
  display: inline-block;
  border-bottom: 2px solid transparent;
}
.tabs a.selected {
  border-bottom: 2px solid var(--colorBgPrimary);
  color: var(--colorBgInverse);
}
.tabs .links {
  position: absolute;
  right: 0;
  top: 6px;
}

.modal-body {
  min-height: 100px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
